export default class DtoCultureRPG {
    constructor(obj) {
        this.code = obj.code // Option[Boolean] = None,
        this.name = obj.name // Option[String] = None,
        this.nameWithCode = `${obj.name} [${obj.code}]`
        this.codeWithName = `[${obj.code}] ${obj.name}`
    }
}